import { useRef } from "react";
import { Button, ButtonProps } from "@heroui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

function FileInput({
    label,
    isLoading,
    onSelect,
    size,
    accept,
    ...props
}: {
    label?: string;
    isLoading?: boolean;
    onSelect?: (file: File) => void;
    size?: "sm" | "md" | "lg";
    accept?: string;
} & ButtonProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleUploadClick = () => {
        inputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            onSelect?.(file);
        }
    };

    return (
        <>
            <input
                type="file"
                ref={inputRef}
                onChange={handleFileChange}
                className="hidden"
                accept={accept}
            />
            <Button
                onPress={handleUploadClick}
                color="primary"
                isLoading={isLoading}
                size={size}
                {...props}
            >
                <FontAwesomeIcon icon={faUpload} />
                {label ?? "Upload"}
            </Button>
        </>
    );
}

export default FileInput;
